import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "health-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "hero-message" }
const _hoisted_4 = { class: "quick-icon-box" }
const _hoisted_5 = { class: "quick-text" }
const _hoisted_6 = { class: "quick-title" }
const _hoisted_7 = { class: "quick-subtitle" }
const _hoisted_8 = { class: "main-content" }
const _hoisted_9 = { class: "quick-list" }
const _hoisted_10 = { class: "quick-icon-box" }
const _hoisted_11 = { class: "quick-text" }
const _hoisted_12 = { class: "quick-subtitle" }
const _hoisted_13 = { class: "q-mb-none text-bold" }
const _hoisted_14 = { class: "row q-col-gutter-md" }
const _hoisted_15 = { class: "row-title" }
const _hoisted_16 = { class: "row-subtitle" }
const _hoisted_17 = { class: "map-box q-mt-md" }

type UserDocument = {
  att_type: number;
  checksum: number;
  date_doc: string;
  datebegin: string;
  doc_name: string;
  doc_type: number;
  file_ext: string;
  id_document: number;
  id_patient: number;
  is_napravlenie: number;
  tg: string;
};
type Map = {
  name: string
  address: string
  buildingCoords: number[],
  entranceCoords?: number[] | null
}


import {
  ref,
  onMounted,
  reactive,
  nextTick,
  computed,
} from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';import copyToClipboard from 'quasar/src/utils/copy-to-clipboard/copy-to-clipboard.js';;
import CenterMap from '@/components/CenterMap.vue';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store';

const __default__ = { name: 'HealthPageFull' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $q = useQuasar();

const loading = ref(true);
const polis = ref<string>('');
const barcodeCanvas = ref<HTMLCanvasElement | null>(null);
const ecoStore = useEcoHospitalStore();

const documents = ref<UserDocument[]>([]);

polis.value = useAuthStore().currentUser?.oms_polis || '';

const copyPolice = async (value: string) => {
  await copyToClipboard(value);
  $q.notify({
    message: 'Номер полиса скопирован в буфер обмена',
    color: 'positive',
    icon: 'check',
  });
};

const maps = reactive<Map[]>([
  {
    name: 'Филиал на ул. Достоевская',
    address: 'ул. Достоевского, 40-44',
    buildingCoords: [59.922327, 30.345347],
    entranceCoords: [59.922467, 30.345367],
  },
  {
    name: 'Филиал на Ладожской',
    address: 'Заневский проспект, 65 к5, этаж 4',
    buildingCoords: [59.932530, 30.433892],
    entranceCoords: [59.932561, 30.433579],
  },
  {
    name: 'Филиал на Звездной',
    address: 'просп. Юрия Гагарина, 65',
    buildingCoords: [59.842066, 30.335850],
    entranceCoords: [59.842121, 30.335983],
  },
]);

// eslint-disable-next-line no-promise-executor-return
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

onMounted(async () => {
  // await delay(1500);
  try {
    loading.value = true;
    documents.value = await ecoStore.getDocuments();
  } catch (error) {
    console.error('Ошибка при загрузке документов:', error);
  } finally {
    loading.value = false;
  }
  nextTick(() => {
    const { PDF417 } = window as any;

    if (PDF417 && polis.value.length) {
      PDF417.draw(
        polis.value,
        barcodeCanvas.value,
        5,
        4,
        window.devicePixelRatio,
        '#000',
      );
    }
  });
});

const filteredDocuments = computed(
  () => documents.value?.filter((doc) => doc.is_napravlenie === 1),
);

const goToDocuments = () => {
  router.push('/patient-documents');
};

const openInNewTab = async (doc: UserDocument) => {
  const path = await ecoStore.getFilePath(doc.id_document);
  if (path[0].hash) {
    window.open(`https://host2.medsafe.tech/${path[0].hash}`, '_tab');
  } else {
    useMainStore().showMessage('Извините, не смогли найти документ.');
  }
};

const actions = [
  {
    title: 'Запись к врачу',
    subtitle: 'Выбрать специалиста',
    icon: 'event_available',
  },
  {
    title: 'Анкетирование',
    subtitle: 'Заполнить опрос',
    icon: 'ballot',
  },
  // {
  //   title: 'Моя поликлиника',
  //   subtitle: 'Адрес и контакты',
  //   icon: 'local_hospital',
  // },
];

const services = [
  {
    id: 1,
    title: 'Приём терапевта',
    date: '10 февраля 2026',
    place: 'Поликлиника №12',
  },
  {
    id: 2,
    title: 'Флюорография',
    date: '22 января 2026',
    place: 'Диагностический центр',
  },
];

const medSections = [
  {
    title: 'Справки и заключения',
    subtitle: 'Выписки, мед. заключения',
  },
  {
    title: 'Направления',
    subtitle: 'Активные и архивные',
  },
  {
    title: 'Протоколы консультаций',
    subtitle: 'История посещений',
  },
  {
    title: 'Протоколы исследований',
    subtitle: 'Анализы и диагностика',
  },
  // {
  //   title: 'Рецепты',
  //   subtitle: 'Назначенные препараты',
  // },
  // {
  //   title: 'Больничные листы',
  //   subtitle: 'Электронные листы нетрудоспособности',
  // },
];

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hero-header" }, [
        _createElementVNode("div", { class: "hero-title" }, "Личный кабинет пациента"),
        _createElementVNode("div", { class: "hero-subtitle" }, " Медицинские документы и направления ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (loading.value)
          ? (_openBlock(), _createBlock(_component_q_skeleton, {
              key: 0,
              height: "90px",
              class: "hero-skeleton"
            }))
          : (_openBlock(), _createBlock(_component_q_card, {
              key: 1,
              class: "hero-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "info",
                      size: "26px",
                      class: "hero-icon"
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hero-text" }, [
                      _createElementVNode("div", { class: "hero-card-title" }, " Актуальные направления ")
                    ], -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDocuments.value, (action) => {
                      return (_openBlock(), _createBlock(_component_q_card, {
                        key: action.id_document,
                        class: _normalizeClass(["quick-item", {
                  'q-mb-sm': filteredDocuments.value.length > 1,
                }])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, {
                            class: "row items-center no-wrap",
                            onClick: ($event: any) => (openInNewTab(action))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_q_icon, {
                                  name: "assignment",
                                  size: "26px",
                                  class: "quick-icon"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(action.doc_name), 1),
                                _createElementVNode("div", _hoisted_7, _toDisplayString(action.date_doc), 1)
                              ]),
                              _createVNode(_component_q_icon, {
                                name: "open_in_new",
                                size: "20px",
                                class: "quick-arrow"
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (loading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (n) => {
              return _createVNode(_component_q_skeleton, {
                key: n,
                height: "70px",
                class: "rounded-lg q-mb-md"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (polis.value.length)
                ? (_openBlock(), _createBlock(_component_q_card, {
                    key: 0,
                    class: "quick-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_q_icon, {
                              name: "badge",
                              size: "26px",
                              class: "quick-icon"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "quick-title" }, " Полис ОМС ", -1)),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("p", _hoisted_13, _toDisplayString(polis.value), 1),
                              _createElementVNode("canvas", {
                                ref_key: "barcodeCanvas",
                                ref: barcodeCanvas
                              }, null, 512)
                            ])
                          ]),
                          _createVNode(_component_q_icon, {
                            name: "content_copy",
                            size: "20px",
                            class: "quick-arrow",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (copyPolice(polis.value)))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "section-title q-mt-xl" }, " Медицинская карта ", -1)),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(medSections, (item) => {
          return _createElementVNode("div", {
            key: item.title,
            class: "col-12 col-md-6"
          }, [
            (!loading.value)
              ? (_openBlock(), _createBlock(_component_q_card, {
                  key: 0,
                  class: "med-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, {
                      class: "row items-center justify-between cursor-pointer",
                      onClick: _withModifiers(goToDocuments, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(item.subtitle), 1)
                        ]),
                        _createVNode(_component_q_icon, {
                          name: "chevron_right",
                          size: "22px"
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_q_skeleton, {
                  key: 1,
                  height: "70px",
                  class: "rounded-lg"
                }))
          ])
        }), 64))
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "section-title q-mt-xl" }, " Адреса филиалов ", -1)),
      _createVNode(_component_q_card, { class: "block-card" }, {
        default: _withCtx(() => [
          (!loading.value)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maps, (map) => {
                      return (_openBlock(), _createBlock(CenterMap, {
                        key: map.name,
                        name: map.name,
                        address: map.address,
                        "building-coords": map.buildingCoords,
                        "entrance-coords": map.entranceCoords
                      }, null, 8, ["name", "address", "building-coords", "entrance-coords"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_skeleton, {
                    height: "160px",
                    class: "rounded-lg"
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})